import Text from '@cartwhl/ui/base/Text';

import type { UploadResult } from '../adminAssetUploadStore';
import { ResultView } from './AdminAssetUpload';

interface ResultItemProps {
  result: UploadResult;
  view: ResultView;
}

export default function ResultItem({ result, view }: ResultItemProps) {
  console.log(result, view);
  return (
    <li>
      <Text variant="studio/body/medium/sm" className="text-primary">
        {view === 'filenames' ? (
          result.fileName
        ) : view === 'paths' ? (
          result.resourcePath
        ) : (
          <a
            href={result.fullUrl}
            className="text-blue underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {result.fullUrl}
          </a>
        )}
      </Text>
    </li>
  );
}
